export const ROLES = {
  GUEST: 'guest',
  USER: 'user',
  ADMIN: 'admin',
};
